<template>
  <div class="wrap">
    <div class="item">
      <IconBase width="120" height="32" :icon-color="consts.COLORS.DARK_300"
                icon-name="logoIcon"/>
    </div>
    <div class="item">
      <switcher unique-id="testMode"
                :is-active="isTestMode"
                text="Test Mode Active"
                text-inactive="Test Mode Inactive"
                :styles="{color: 'orange', size: 'small'}"
                :is-disabled="viewOnly"
                @changed="changed"
      ></switcher>
      <span v-if="showBannerTooltip" class="tooltip">
                <tooltip
                  text="ironSource Network does not support A/B testing for
                  Banner therefore it can only be active
                   in the A variant of a given test"></tooltip>
            </span>
    </div>
  </div>
</template>

<script>
import consts from 'services/metaData/consts';
import IconBase from 'components/IconBase.vue';
import Tooltip from 'components/Tooltip/Tooltip.vue';
import switcher from 'components/Switcher.vue';

export default {
    name: 'Status',
    components: {
        switcher,
        Tooltip,
        IconBase
    },
    props: {
        isTestMode: {
            type: Boolean,
            default: false
        },
        viewOnly: {
            type: Boolean,
            default: false
        },
        showBannerTooltip: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            consts
        }
    },
    methods: {
        changed() {
            this.$emit('changed', !this.isTestMode);
        }
    }
};
</script>

<style scoped lang="scss">
  @import "~styles/styleGuide";
  @import "~styles/checkbox";

  .wrap {
    display: grid;
    justify-content: stretch;
    grid-template-columns: 170px 80%;
    grid-template-rows: 32px;
    padding: 15px;
  }

  .tooltip {
    vertical-align: top;
    padding-left: 5px;
  }

  .item {
    line-height: 32px;
  }
</style>
